webpackJsonp([63],{

/***/ 502:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_sidebar_vue__ = __webpack_require__(785);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce44b1ac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_sidebar_vue__ = __webpack_require__(933);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce44b1ac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 785:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);



var loadCompanies = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
		var _ref2, companies;

		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.next = 2;
						return this.$http.get('project/' + this.codeProject + '/companies');

					case 2:
						_ref2 = _context.sent;
						companies = _ref2.data;

						this.companies = companies.data;
						this.codeCompany = companies.data[0].codeCompany;
						this.loadRoles();

					case 7:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function loadCompanies() {
		return _ref.apply(this, arguments);
	};
}();

var loadRoles = function () {
	var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
		var _ref4, roles;

		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						_context2.next = 2;
						return this.$http.get('company/' + this.codeCompany + '/project/' + this.codeProject + '/role');

					case 2:
						_ref4 = _context2.sent;
						roles = _ref4.data;

						this.roles = roles.data;

					case 5:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this);
	}));

	return function loadRoles() {
		return _ref3.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function created() {
	this.loadCompanies();
}

function loadSidebar() {}

function data() {
	return {
		codeCompany: '',
		companies: [],
		roleId: 0,
		roles: []
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'page-sidebar',
	created: created,
	data: data,
	methods: {
		loadCompanies: loadCompanies,
		loadRoles: loadRoles,
		loadSidebar: loadSidebar
	},
	props: {
		codeApp: {
			type: String
		},
		codeProject: {
			type: String
		}
	}
});

/***/ }),

/***/ 933:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('header-page',{attrs:{"name":"sidebar","title":_vm.$route.meta.title}}),_vm._v(" "),_c('general-filter',{staticClass:"mt-4"},[_c('v-flex',{attrs:{"xs12":"","sm3":"","pr-3":""}},[_c('v-select',{staticClass:"body-1",attrs:{"background-color":"white","box":"","hide-details":"","items":_vm.companies,"item-text":"nombreComercial","item-value":"codeCompany","label":"Compañías"},on:{"input":_vm.loadRoles},model:{value:(_vm.codeCompany),callback:function ($$v) {_vm.codeCompany=$$v},expression:"codeCompany"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","pr-3":""}},[_c('v-select',{staticClass:"body-1",attrs:{"background-color":"white","box":"","hide-details":"","disabled":!_vm.codeCompany,"items":_vm.roles,"item-text":"name","item-value":"id","label":"Roles"},on:{"input":_vm.loadSidebar},model:{value:(_vm.roleId),callback:function ($$v) {_vm.roleId=$$v},expression:"roleId"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/63.fd2fdac6842479ac1040.js